import { styled } from '../../../config'
import { Text } from '../../Text'

export const Title = styled(Text, {
  fontSize: '16px',
  color: '$white'
})
